import { environment } from 'src/environments/environment';
import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { AuthComponent } from '../auth/auth.component';
import { Helper } from 'src/app/shared/helper';
import { AdminSettingsService } from 'src/app/shared/admin-settings.service';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { DEFAULT_IMAGE } from 'src/app/core/constant/constant';
import { assetsModel } from 'src/app/core/models/assets.model';
import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
import lgZoom from 'lightgallery/plugins/zoom';
import { BeforeSlideDetail } from 'lightgallery/lg-events';
import { LightgalleryComponent } from 'lightgallery/angular';
import { LightGallery } from 'lightgallery/lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import { CategoryService } from 'src/app/data/services/category.service';
import { ProductService } from 'src/app/data/services/product.service';
import { ProductDetailModalComponent } from 'src/app/layout/modals/product-detail-modal/product-detail-modal.component';
import { LanguageService } from 'src/app/shared/language.service';

declare var $: any;

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent {

  imageUrl = environment.IMAGE_URL;
  @ViewChild('authModel', { static: false }) authModel!: AuthComponent;
  DEFAULT_IMAGE = DEFAULT_IMAGE;
  assetsList: assetsModel[] = [];
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    navSpeed: 700,
    margin: 40,
    navText: ['', ''],
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 1
      },
      740: {
        items: 1
      },
      940: {
        items: 1
      }
    },
    nav: true
  }
  current_page: number = 1;
  items_per_page: number = 3;
  selected_tab: number = 1;
  private lightGallery!: LightGallery;
  private needRefresh = false;
  bannerImages: any[] = [];
  categoryList: any[] = [];
  productList: any[] = [];
  page: number = 1; // Start with page 1
  limit: number = 8; // Initial limit is 8 products
  totalProducts: number = 0; // Store total product count
  items: any[] = [];
  settings = {
    counter: false,
    dynamic: true,
    dynamicEl: this.items,
    plugins: [lgZoom, lgThumbnail]
  };
  active = 1;

  hoveredProductId!: string;  // Holds the current image during hover

  @ViewChild('lightbox', { static: false }) lightbox?: LightgalleryComponent
  @ViewChild('productDetailModal', { static: false })
  productDetailModal!: ProductDetailModalComponent;
  constructor(
    public helper: Helper,
    private config: NgbCarouselConfig,
    private categoryService: CategoryService,
    private productService: ProductService,
    private adminSettingsService: AdminSettingsService,
    private languageService: LanguageService
  ) {
    config.interval = 10000;
    config.wrap = false;
    config.keyboard = false;
    config.pauseOnHover = false;

    // Refresh categories when language changes
    this.languageService.languagesObservable.subscribe((data) => {
      if (data) {
        this.getCategoryList();
      }
    });
  }

  onBeforeSlide = (detail: BeforeSlideDetail): void => {
    const { index, prevIndex } = detail;
  };

  goNext() {
    const swiper = document.querySelector('.jewelry-swiper') as any;
    swiper.swiper.slideNext();
  }

  goPrev() {
      const swiper = document.querySelector('.jewelry-swiper') as any;
      swiper.swiper.slidePrev();
  }

  async ngOnInit() {
    this.loadBanners();
    await this.getCategoryList();
  }

  loadBanners() {
    const localHeroes = [
      'assets/img/home-page/IMG_0405.JPG'
    ];
    if (this.helper.adminSettings) {
      const banners = (this.helper.adminSettings.bannerImage || []).filter((b: any) => !!b && String(b).trim() !== '');
      this.bannerImages = banners.length > 0 ? [banners[0]] : [...localHeroes];
    } else {
      this.bannerImages = [...localHeroes];
      this.adminSettingsService.getAdminDetails().subscribe({
        next: (res: any) => {
          if (res && res[0]) {
            const banners = (res[0].bannerImage || []).filter((b: any) => !!b && String(b).trim() !== '');
            this.bannerImages = banners.length > 0 ? [banners[0]] : [...localHeroes];
          }
        }
      });
    }
  }

  handleBannerError(event: any): void {
    event.target.src = 'assets/img/home-page/IMG_0405.JPG';
  }

  getCategoryList(): Promise<void> {
    const parameters = { page: 1, limit: 1000, sortField: 'sortOrder', sortOrder: 1, useLocalizedFields: true , isActive : true}
    return new Promise((resolve, reject) => {
      this.categoryService.getCategoryList(parameters).subscribe((response: any) => {
        if (response) {
          this.categoryList = response.data.categories;
        } else {
          this.categoryList = [];
        }
        resolve();
      });
    });
  }

  getproductList(loadMore: boolean = false): Promise<void> {
    const parameters = {
      page: this.page,
      limit: this.limit,
      sortField: 'sortOrder',
      sortOrder: 1,
      useLocalizedFields: true, isActive : true
    };

    return new Promise((resolve, reject) => {
      this.productService.getproductList(parameters).subscribe((response: any) => {
        if (response && response.data) {
          if (loadMore) {
            // Append new products to the list
            this.productList = [...this.productList, ...response.data.products];
          } else {
            // Load the initial products
            this.productList = response.data.products;
          }
          this.totalProducts = response.data.dataCount; // Assume API returns total product count
        } else {
          if (!loadMore) {
            this.productList = [];
          }
        }
        resolve();
      });
    });
  }

  loadMoreProducts() {
    this.page++; // Increment the page number
    this.getproductList(true); // Pass true to append products
  }

  // Breakpoints for responsive design
  breakpoints = {
    640: { slidesPerView: 1, spaceBetween: 10 },
    768: { slidesPerView: 2, spaceBetween: 15 },
    1024: { slidesPerView: 3, spaceBetween: 20 },
    1280: { slidesPerView: 4, spaceBetween: 30 },
  }

  onSlideChange(event: any) {
    // console.log('Slide changed:', event);
  }

  onInit = (detail: any): void => {
    this.lightGallery = detail.instance;
  };


  onRegister() {
    this.authModel.registerModal();
  }

  viewProduct(product: any):void {
    this.productDetailModal.open(product._id);
		// this.helper._route.navigate(['/app/product-detail/', product._id]); // Pass the product ID
	}

  	// Update current image on hover
    onHover(product: any): void {
      if(product.images.length > 0) {
        this.hoveredProductId = product._id;  // Set the ID of the hovered product
      }
    }
  
    // Reset hovered product ID on hover out
    onHoverOut(): void {
      this.hoveredProductId = '';  // Reset hovered product ID
    }

  selectCategoryWiseProductList(category: any) {
    this.helper.selectedCategory = category;
    this.helper._route.navigate(['/product']);
  }

  openGallery(asset: any) {
    if (asset.assetsImage.length > 0) {
      this.items = [];
      asset.assetsImage.forEach((image: any, index: any) => {
        this.items.push({ id: index, src: this.imageUrl + 'assetsImage/' + image, thumb: this.imageUrl + 'assetsImage/' + image })
      });

      this.lightGallery.refresh(this.items);
      this.lightGallery.openGallery();
      this.needRefresh = false;
    }
  };
}
